import React, { ChangeEvent, FC } from 'react';
import { Form } from 'react-bootstrap';

interface PropTypes {
    value: boolean | undefined;
    handleOnChange: (value: string) => void;
    disabled?: boolean;
}

export const BooleanInput: FC<PropTypes> = ({ value, handleOnChange, disabled, ...props }) => {

    const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
        handleOnChange(e.target.checked.toString());
    };

    return <Form.Check
        type="switch"
        role="switch"
        checked={value}
        onChange={e => handleToggle(e)}
        disabled={disabled}
        {...props}>
    </Form.Check>;
};

export const parseBooleanString = (value: string) => {
    return value.length > 0 ? value.toLowerCase() === 'true' : undefined;
};
